export enum SupportedLocales {
    'en' = 'en',
    'en-us' = 'EnUs',
    'de' = 'De',
    'fr' = 'Fr',
    'es' = 'Es',
    'it' = 'It',
    'pt' = 'Pt',
    'ru' = 'Ru',
    'zh' = 'Zh',
    'id' = 'Id',
    'bs' = 'Bs',
    'ca' = 'Ca',
    'cs' = 'Cs',
    'da' = 'Da',
    'es-co' = 'EsCo',
    'es-mx' = 'EsMx',
    'es-ar' = 'EsAr',
    'gl' = 'Gl',
    'hr' = 'Hr',
    'sw' = 'Sw',
    'lv' = 'Lv',
    'lt' = 'Lt',
    'hu' = 'Hu',
    'ms' = 'Ms',
    'nl' = 'Nl',
    'nb' = 'Nb',
    'pl' = 'Pl',
    'pt-pt' = 'PtPt',
    'ro' = 'Ro',
    'sq' = 'Sq',
    'sl' = 'Sl',
    'sk' = 'Sk',
    'sr' = 'Sr',
    'fi' = 'Fi',
    'sv' = 'Sv',
    'tl' = 'Tl',
    'vi' = 'Vi',
    'tr' = 'Tr',
    'el' = 'El',
    'bg' = 'Bg',
    'uk' = 'Uk',
    'he' = 'He',
    'ar' = 'Ar',
    'hi' = 'Hi',
    'th' = 'Th',
    'zh-Hant' = 'ZhHant',
    'ja' = 'Ja',
    'ko' = 'Ko',
}
